module.exports = __webpack_public_path__ + "img/icon_change.4e162879.svg";